import { Injectable } from '@angular/core';
import {  HttpClient,  HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import {map} from 'rxjs/operators';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';


@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  // private _url: string = 'http://54.224.201.194:443/shopping-car-service/V1.0.0/shopppingCarService/';
  // private _url: string = 'https://4cneincpnf.execute-api.us-east-1.amazonaws.com/dev/shoppingCar/';
  private _httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private httpClient: HttpClient,public cookieCiencuadras: CookieCiencuadras) { 
  }

  public getPlans(idTipoCliente: string): Observable<any> {
  //   let authToken = this.cookieCiencuadras.getCookie('authToken');
  //   debugger
  //  if(authToken === ''){
  //   debugger
  //   this.getAuthToken();
  //  }
    return this.httpClient.get<any>(`${environment.urlShoppingCar}getPlansByTipoUsuario/${idTipoCliente}`,
      {
        headers: this._httpHeaders,
      }
    );
  }

  public getProducts(): Observable<any> {
    console.log(`${environment.urlShoppingCar}getAllProducts`);
    return this.httpClient.get<any>(`${environment.urlShoppingCar}getAllProducts`,
      {
        headers: this._httpHeaders,
      }
    );
  }

  public activePlans(id: number): Observable<any> {
    // https://4cneincpnf.execute-api.us-east-1.amazonaws.com/dev/users/activePlans?id_user=7690
    return this.httpClient.get<any>(`${environment.urlUserInformation}/activePlans?id_user=${id}`,
      {
        headers: this._httpHeaders,
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  public getBasePaymentByUserId(idUser: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.urlShoppingCar}getBasePaymentByUserId/${idUser}`,
    {
    headers: this._httpHeaders,
    }
    );
  }

  public getUserInformation(user_id: string): Observable<any> {
    // https://qa.ciencuadras.com/site/get-info-user?userId=pjprya4kY3Es1cKbTH-8xNB66I78MjGYZxQuuAZsVqU%3D
    return this.httpClient.get<any>(`${environment.environmenturl}site/get-info-user?userId=${user_id}`,
    //return this.httpClient.get<any>(`https://run.mocky.io/v3/430e08a1-e4d6-4312-9386-eda5f5723cd4`,
    {
    headers: this._httpHeaders,
    }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  public getTransaccionCarritoByToken(user_id: string): Promise<any> {
    // https://qa-api-backend.ciencuadras.com/stage/shoppingCar/getTransaccionCarritoByToken/UTCVxuDeFH
    return this.httpClient.get<any>(`${environment.urlShoppingCar}getTransaccionCarritoByToken/${user_id}`,
    {
    headers: this._httpHeaders,
    }
    ).toPromise();
  }

  public updateUserInformation(user_id: string, phone: string, cellPhone: string) {
    // https://dev.ciencuadras.com/site/update-info-user

      let formdata = new FormData();
      formdata.append('user_id' , user_id)
      formdata.append('telefono' , phone)
      formdata.append('celular' , cellPhone)
    
      return this.httpClient.post<any>(`${environment.environmenturl}site/update-info-user`, formdata)
      .pipe(map(response => {
        return response;
    }));
  }

  public financialInfoUser(userID: string){

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let options = { headers: headers };

    return this.httpClient.get<any>(`${environment.lambdaApiUrl}/users/financialInfoUser?id_user=${userID}`, options)
      .pipe(map(userInformation => {
        return userInformation;
      }));

  }

  public getAuthTokenService() {
    let params = new HttpParams({
      fromObject: { grant_type: 'client_credentials' },
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': '*/*',
        'Authorization': 'Basic ' + btoa(`${environment.authUser}:${environment.authPass}`)
      }),
    };

    return this.httpClient.post<any>(environment.urlAuthToken,
      params.toString(),
      httpOptions
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  public addBulkProducts(data:any): Promise<any> {

    return this.httpClient.post<any>(`${environment.urlShoppingCar}addBulkProducts`,
      data,
      {
        headers: this._httpHeaders,
      }
      ).toPromise();
  }

  public savePurchaseIntent(
    apellidos: string,
    correoElectronico: string,
    nombres: string,
    numeroCelular: string,
    tipoDocumento: number,
    token: any,
    transaccionCarritoDet: [
      {
        "padreId"?: number, // id del plan
        "cantidad": number,
        "itemId": number, // id
        "tipo": number, // 1 plan, 2 producto
        "valorTotal": number
      }
    ],
    usuarioId: number,
    valorTotal: number,
  ) {

    // osea cuando el es tipo 1 el padreId es null cuando el 2 se manda el id del plan
    let json =
    {
      "apellidos": apellidos,
      "correoElectronico": correoElectronico,
      "nombres": nombres,
      "numeroCelular": numeroCelular,
      "tipoDocumento": tipoDocumento,
      "token": token,
      "transaccionCarritoDet": transaccionCarritoDet,
      "usuarioId": usuarioId,
      "valorTotal": valorTotal
    };
    return this.httpClient.post<any>(`${environment.urlShoppingCar}savePurchaseIntent`,
      json,
      {
        headers: this._httpHeaders,
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  public saveBillingInfo(bodyRequest: any) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    let options = { headers: headers};
    return this.httpClient.post<any>(`${environment.lambdaApiUrl}/users/save-piece-rate-products`, bodyRequest, options)
      .pipe(map(response => {
        console.log('Response Lambda new: ', response);
        return response;
      }));
  }

  public userTypeChange() {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }),
    };
    const userId = parseInt(this.cookieCiencuadras.getCookie('idUser'));
    const newUserType = 3;
    let bodyData = {
      userId: userId,
      newUserType: newUserType,
    };
    return this.httpClient.post<any>(`${environment.lambdaApiUrl}/users/user-type-change`, bodyData, httpOptions)
      .pipe(map(response => {
        console.log('Response Lambda user type change new: ', response);
        return response;
      }));
  }

  /**
   * * Metodo que retorna el tipo de cliente segun el tipo de usuario que viene en typeUser
   * @param typeUser tipo de usuario que viene en la cookie typeUser cuando se loguea
   * @returns clientType
   */
  getClientType(typeUser: string): string {
    switch (typeUser.toLowerCase()) {
      case 'inmobiliaria':
        return '1';
      case 'agente-inmobiliario':
        return '2';
      case 'constructora':
        return '3';
      default:
        return '';
    }
  }

  /**
   * * Metodo que setea la cookie de loginUserType y envía el tag de analitica
   * @param clienTypeSelected codigo del tipo de cliente seleccionado
   */
  getLoginUserTypeAndUserType(clienTypeSelected: string): {loginUserType: string, userType} {
    let userType = '';
    let loginUserType = '';

    switch (clienTypeSelected) {
      case '1':
        loginUserType = '2';
        userType = 'inmobiliaria';
        break;
      case '2':
        loginUserType = '3';
        userType = 'agentes';
        break;
      case '3':
        loginUserType = '4';
        userType = 'constructora';
        break;
      case '4':
        loginUserType = '9';
        userType = 'personas';
        break;
    }

    return {loginUserType, userType};
  }

  /**
   * * Metodo que setea las cookies y el localStorage necesario para el funcionamiento de los planes por tipo de usuario
   * @param clientType codigo del tipo de cliente
   */
  setClientType(clientType: string) {
    this.cookieCiencuadras.setCookie('clientType', clientType);
    this.cookieCiencuadras.setCookie('planType', '2');
    localStorage.setItem('clientType', clientType);
    this.setIdclientType();
    const userInfo = this.getLoginUserTypeAndUserType(clientType);
    this.cookieCiencuadras.setCookie('loginUserType', userInfo.loginUserType);
  }

  /**
   * * Metodo que retorna el titulo que se debe colocar por tipo de cliente
   * @param clientType codigo del tipo de cliente
   * @returns titulo correspondiente por tipo de cliente
   */
  getTitleByUserType(clientType: string): string {
    switch (clientType) {
      case '1':
        return 'Planes de publicación para inmobiliarias';
      case '2':
        return 'Planes de publicación para agentes inmobiliarios';
      case '3':
        return 'Planes de publicación para constructoras';
      default:
        return 'Planes de publicación';
    }
  }

  /**
   * * Metodo que setea el idClientType y lo devuelve
   * @returns devuelve el idClientType del tipo de usuario
   */
  setIdclientType(): string {
    let idClientType: string;
    switch (this.cookieCiencuadras.getCookie('typeUser')) {
      case 'Inmobiliaria':
        idClientType = '1';
        break;
      case 'Agente independiente':
        idClientType = '2';
        break;
      case 'Constructora':
        idClientType = '3';
        break;
      case 'Persona Natural':
        idClientType = '4';
        break;
      default:
        idClientType = '';
        break;
    }
    this.cookieCiencuadras.setCookie('idClientType', idClientType);
    return idClientType;
  }
}
